import { render } from "./RegisterTypeSelectionScreen.vue?vue&type=template&id=18143c72"
import script from "./RegisterTypeSelectionScreen.vue?vue&type=script&lang=js"
export * from "./RegisterTypeSelectionScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__